import {
  parseISO,
  isSameDay,
  isYesterday,
  differenceInCalendarDays,
  format,
} from "date-fns";

const WEEKDAYS = [
  "Domingo",
  "Segunda",
  "Terça",
  "Quarta",
  "Quinta",
  "Sexta",
  "Sábado",
];

// Formata data/hora no estilo WhatsApp:
//  - hoje         -> "HH:mm"
//  - ontem        -> "Ontem HH:mm"
//  - últimos 7 d  -> "Segunda HH:mm"
//  - mais antigo  -> "dd/MM/yyyy HH:mm"
export const formatWhatsappTime = value => {
  if (!value) return "";
  let date;
  try {
    date = typeof value === "string" ? parseISO(value) : value;
  } catch (_e) {
    return "";
  }
  if (!date || Number.isNaN(date.getTime())) return "";

  const now = new Date();
  if (isSameDay(date, now)) return format(date, "HH:mm");
  if (isYesterday(date)) return `Ontem ${format(date, "HH:mm")}`;
  if (differenceInCalendarDays(now, date) < 7) {
    return `${WEEKDAYS[date.getDay()]} ${format(date, "HH:mm")}`;
  }
  return format(date, "dd/MM/yyyy HH:mm");
};

export default formatWhatsappTime;
